import { DataGridPro as NovaDataGridPro } from '@fme-nova/components'
import { DataGridPro, DataGridProProps, GridColDef, GridMoreVertIcon, GridRenderCellParams } from '@mui/x-data-grid-pro'
import React from 'react'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

export { GridMoreVertIcon }
export type { GridRenderCellParams }

export type { GridColDef }

export const DataGrid = createComponentWrapperWithRef<DataGridProProps>(
  {
    mui: DataGridPro,
    nova: NovaDataGridPro as unknown as React.ComponentType<DataGridProProps>,
  },
  'DataGrid',
)

export const StyledDataGrid: MsdkStyledComponent<DataGridProProps> = styled(DataGridPro)`
  border-radius: 5px;
  border: none;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  [role='rowgroup'] {
    padding: 16px 24px;
  }

  .MuiDataGrid-cell,
  .MuiDataGrid-cell:focus,
  .MuiDataGrid-cell:focus-within,
  .MuiDataGrid-cell:focus-visible {
    border: none;
  }
`
